import configure from "@/Plugins/configure.js";
import { createInertiaApp, router } from "@inertiajs/vue3";
import axios from "axios";
import { createApp, h } from "vue";
import "../css/app.css";
import { resolvePageComponent } from "laravel-vite-plugin/inertia-helpers";
import { initInertiaErrorHandler } from "@/Helpers/inertiaErrorHandler.js";
import { loadLocale } from "@/Plugins/i18n.js";
import { initNative } from "@/Helpers/capacitor.js";
import { initPageTransitions } from "@/Helpers/pageTransitions.js";
import { trackPageView } from "@/Helpers/pageView.js";

axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

initInertiaErrorHandler();

createInertiaApp({
    progress: {
        color: "#0E5425",
    },
    title: (title) => `LemonSwan - ${title}`,
    resolve: (name) =>
        resolvePageComponent(
            `./Pages/${name}.vue`,
            import.meta.glob("./Pages/**/*.vue")
        ),
    async setup({ el, App, props, plugin }) {
        const locale =
            props.initialPage.props.locale || window.config?.locale || "de";
        await loadLocale(locale);

        initPageTransitions();

        configure(createApp({ render: () => h(App, props) }).use(plugin)).mount(
            el
        );

        initNative();
    },
});

router.on("navigate", trackPageView);
